<template>
  <b-modal
    @ok="submitForm"
    ok-title="Submit"
    v-if="product"
    :id="'enquire-modal-' + product.id"
    size="lg"
    :title="'Enquire about ' + product.title"
  >
    <b-overlay :show="loading">
      <b-form @submit.stop.prevent="submitForm">
        <b-form-group
          :id="'enquire-modal-input-name-label-' + _uid"
          label="Your Name"
          :label-for="'enquire-modal-input-name-input-' + _uid"
        >
          <b-form-input
            :id="'enquire-modal-input-name-input-' + _uid"
            name="name"
            v-model="$v.form.name.$model"
            :state="validateState('name')"
            :aria-describedby="'enquire-modal-input-name-feedback-' + _uid"
          ></b-form-input>
          <b-form-invalid-feedback
            :id="'enquire-modal-input-recipient-feedback-' + _uid"
          >
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          :id="'enquire-modal-input-email-label-' + _uid"
          label="Email Address"
          :label-for="'enquire-modal-input-email-input-' + _uid"
        >
          <b-form-input
            :id="'enquire-modal-input-email-input-' + _uid"
            name="email"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            :aria-describedby="'enquire-modal-input-email-feedback-' + _uid"
          ></b-form-input>
          <b-form-invalid-feedback
            :id="'enquire-modal-input-email-feedback-' + _uid"
          >
            This must be a valid email address.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          :id="'enquire-modal-input-caseqty-label-' + _uid"
          label="Number of cases to buy?"
          :label-for="'enquire-modal-input-caseqty-input-' + _uid"
        >
          <b-form-input
            :id="'enquire-modal-input-caseqty-input-' + _uid"
            name="caseqty"
            type="number"
            v-model="$v.form.caseqty.$model"
            :state="validateState('caseqty')"
            :aria-describedby="'enquire-modal-input-caseqty-feedback-' + _uid"
          ></b-form-input>
          <b-form-invalid-feedback
            :id="'enquire-modal-input-caseqty-feedback-' + _uid"
          >
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          :id="'enquire-modal-input-comment-label-' + _uid"
          label="Comment"
          :label-for="'enquire-modal-input-comment-input-' + _uid"
        >
          <b-form-input
            :id="'enquire-modal-input-comment-input-' + _uid"
            name="comment"
            v-model="$v.form.comment.$model"
            :state="validateState('comment')"
            :aria-describedby="'enquire-modal-input-comment-feedback-' + _uid"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <p>Different case sizes may be available on request.</p>
    </b-overlay>
  </b-modal>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

export default {
  props: {
    product: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        name: this.$store.state.user.customer_name ?? "",
        email: this.$store.state.user.user_email ?? "",
        caseqty: "1",
        comment: "",
      },
    };
  },
  validations() {
    return {
      form: {
        name: {
          required,
        },
        email: {
          required,
          email,
        },
        caseqty: {
          required,
        },
        comment: {},
      },
    };
  },
  methods: {
    submitForm(e) {
      e.preventDefault();

      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      this.$store
        .dispatch("basket/enquire", {
          ...this.form,
          product: this.product.id,
        })
        .then(() => {
          this.$bvModal.hide("enquire-modal-" + this.product.id);
          this.$bvModal.msgBoxOk(
            "Thank you, your enquiry has been submitted. We will contact you with 2 working days to discuss your purchase."
          );
        })
        .catch((err) => {
          this.showError(
            "Error sending enquiry",
            "Your enquiry could not be sent at this time. Please try again later",
            err
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>